<template>
    <span
        v-tooltip="'Komunikaty'"
        class="dropdown"
        :class="{ show: showUserNav }"
        v-click-outside="hideUserNav"
        v-if="news"
    >
        <button
            @click="toggleMenu"
            class="p-0 btn btn-link"
            type="button"
            data-toggle="dropdown"
            :aria-haspopup="showUserNav"
            aria-expanded="false"
        >
            <span
                class="menu-message-icon d-flex"
                :class="{ zeroNew: newsReadCount === 0 }"
                :data-menu-messages-counter="newsReadCount"
            >
                <a-icon width="24px" height="24px" icon="Envelope" />
            </span>
        </button>

        <transition name="slide">
            <div
                v-if="showUserNav"
                class="menu-dropdown dropdown-responsive message-menu dropdown-menu dropdown-menu-right"
                :class="{ show: showUserNav }"
            >
                <ul class="navbar-nav flex-column">
                    <li class="nav-item" v-for="(item, idx) in news" :key="idx">
                        <router-link
                            :to="{ name: 'notifications' }"
                            class="nav-link message-link"
                            href="#"
                            :class="{ 'is-read': item.read }"
                            @click.native="goToNews(item.id)"
                        >
                            <a-icon
                                style="width: 24px; height: 24px"
                                icon="Circle"
                            />
                            <span>{{ item.title }}</span>
                        </router-link>
                    </li>
                    <li class="nav-item mt-2">
                        <router-link
                            :to="{ name: 'notifications' }"
                            class="nav-link text-body"
                            href="#"
                            @click.native="showUserNav = false"
                        >
                            <a-icon icon="Right" />
                            <span>Wszystkie komunikaty</span>
                        </router-link>
                    </li>
                </ul>
            </div>
        </transition>
    </span>
</template>

<script>
export default {
    data() {
        return {
            showUserNav: false
        }
    },
    methods: {
        hideUserNav() {
            if (this.showUserNav) {
                this.showUserNav = false
            }
        },
        fetch() {
            this.$store
                .dispatch('newsFetch', {
                    limit: 5,
                    offset: 0
                })
                .then(() => {
                    this.$store.dispatch('alertsFetch')
                })
        },
        goToNews(newsId) {
            this.hideUserNav()
            this.$store.dispatch('setNewsOffset', 0)
            this.$store.dispatch('setActiveNews', newsId).then(() => {
                if (
                    this.$router.currentRoute.name ===
                    this.$router.resolve({ name: 'notifications' }).location
                        .name
                ) {
                    this.$store.dispatch('markOneNewsAsRead', newsId)
                }
            })
        },
        toggleMenu() {
            this.showUserNav = !this.showUserNav
            if (window.innerWidth < 992) {
                this.$store.dispatch('toggleMobileMenu', false)
            }
        }
    },
    computed: {
        news() {
            return this.$store.getters.getNewsHeader
        },
        newsReadCount() {
            return this.news.filter(el => !el.read).length
        }
    },
    created() {
        // this.fetch()
    }
}
</script>

<style scoped>
.navbar-nav .nav-link.message-link.active {
    color: #041e42;
}
</style>
